/**
 * AI Service
 */
import httpClient from "./http.client"

/**
 * Generate filter expressions based on a prompt
 *
 * @param {string} prompt - The prompt to generate filter expressions for
 * @param {Object} params - Optional query parameters
 * @returns {Promise} - Promise resolving to the generated filter expressions
 */
export function generateFilter(prompt, params = {}) {
  return httpClient.post(`/api/generate-filter-expressions/`, { prompt }, { params }).then((response) => response.data)
}

export default {
  generateFilter
}
